import { useParams } from "next/navigation";
import { vi, enUS } from "date-fns/locale";
import { format } from "date-fns";

export const useLocale = (): string => {
  const params = useParams();
  const locale = params?.locale as string;

  // Default to 'en' if locale is not found
  return locale || "en";
};

export const useLocaleDateFormatter = (timeFormat?: string) => {
  const locale = useLocale();
  const localeMap = {
    vi: vi,
    en: enUS,
  };
  const timeFormatString = timeFormat ? `${timeFormat} ` : "";
  return {
    dateFormatter: (date: string | Date | undefined) =>
      date
        ? format(
            date,
            locale === "vi"
              ? `${timeFormatString}dd/MM/yyyy`
              : `${timeFormatString}MMM dd, yyyy`,
            {
              locale: localeMap[locale as keyof typeof localeMap],
            },
          )
        : "",
  };
};
